export class SharedPermissionKey {
  static readonly USER_ADMIN = 'shared/permission/user-admin';
  static readonly EMPLOYEE_ADMIN = 'time-recording/permission/employee-admin';
  static readonly COMPANY_ADMIN = 'shared/permission/company-admin';
  static readonly PROJECT_OVERVIEW = 'shared/permission/project-overview';
  static readonly PROJECT = 'shared/permission/project';
  static readonly PROJECT_ADMIN = 'shared/permission/project-admin';
}
